<template>
  <Modal
    name="signIn"
    data-testid="signin-modal"
    modal-overlay-classes="sm:px-big sm:pb-large px-0 pb-0 pt-12 md:p-0 sm:justify-center justify-start"
    modal-classes="relative mx-auto bg-white h-fit w-fit p-0"
    :is-open="modalOpen"
    @close="closeModal"
  >
    <SignInForm
      :image="image"
      :title="title"
      :is-price-spotlight-login="isPriceSpotlightLoginVariantActive"
      @on-submitted="closeModal"
      @open-create-account-modal="openCreateAccountModal"
      @open-forgot-password-modal="openForgotPasswordModal"
    />
  </Modal>
</template>

<script setup lang="ts">
import Modal from '~/components/common/ModalV2.vue'
import SignInForm from '~/components/SignInForm.vue'
import { getRandomLoginImage } from '~/src/constants/auth'
import { useModalStore } from '~/stores/modal'
import { createAccountStore } from '~/stores/createAccount'

const MODAL_NAME = 'signIn'

const { hubspotCreateAccountFormId, hubspotCreateAccountForm } =
  useRuntimeConfig().public

const modalStore = useModalStore()
const createAccount = createAccountStore()

const { close, open, setPriceSpotlightLoginVariantActive } = modalStore
const { modals, isPriceSpotlightLoginVariantActive } = storeToRefs(modalStore)
const image = ref<string>(getRandomLoginImage())

const formId = computed(() => {
  return !isPriceSpotlightLoginVariantActive.value
    ? hubspotCreateAccountFormId
    : hubspotCreateAccountForm
})

const title = computed(() => {
  return isPriceSpotlightLoginVariantActive.value
    ? 'Sign In to view the Price Spotlight'
    : 'Sign In'
})

const openCreateAccountModal = () => {
  createAccount.setFormId(formId.value)
  close('signIn')
  open('createAccount')
}

const openForgotPasswordModal = () => {
  close('signIn')
  open('forgotPassword')
}

const closeModal = () => {
  setPriceSpotlightLoginVariantActive(false)
  close(MODAL_NAME)
}
const modalOpen = computed(() => modals.value[`${MODAL_NAME}Open`])
</script>
